import clsx from 'clsx';
import ErrorMessage from '../../features/ErrorMessage/ErrorMessage';
import React from 'react';
import SearchTripsModal from '../../features/SearchTrips/SearchTripsModal/SearchTripsModal';
import SearchTripsTable from '../../features/SearchTrips/SearchTripsTable/SearchTripsTable';
import { Dimmer, Loader } from 'semantic-ui-react';
import { useBreakpoint } from '../../hooks/BreakPointProvider/breakpoint';
import { Route } from 'react-router-dom';
import { useTripsQuery } from '../../queries/hooks/useTripsQuery/useTripsQuery';
import './styles.scss';

import {
  searchTripItineraryResponsePath,
  searchTripRawResponsePath,
  searchTripResponsePath,
} from '../../paths';

const SearchTripsResult: React.FC = () => {
  const [{ isLoading: isTripsLoading, error: tripsError, isNotFound }] = useTripsQuery();
  const breakpoints = useBreakpoint();

  return (
    <div className="search-trips-page-content-container">
      {isTripsLoading && (
        <Dimmer active inverted data-testid="search-trips-page-loader">
          <Loader size="massive" />
        </Dimmer>
      )}

      <div
        className={clsx('search-trips-content-container', { 'table-sticky-container': !breakpoints.xs })}
        data-testid="search-trips-content-container"
      >
        {!isTripsLoading && (!tripsError || isNotFound) && <SearchTripsTable />}
        {tripsError && !isNotFound && <ErrorMessage dataTestid="search-trips-page-error-message" />}
      </div>

      <Route
        path={[searchTripResponsePath(), searchTripItineraryResponsePath(), searchTripRawResponsePath()]}
        component={SearchTripsModal}
      />
    </div>
  );
};

export default SearchTripsResult;
